import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import { useChipiContext } from "../context";
import type {
  RecordSendTransactionParams,
  Transaction,
} from "@chipi-stack/types";

type RecordSendTransactionInput = {
  params: RecordSendTransactionParams;
  bearerToken: string;
};

export function useRecordSendTransaction(): {
  recordSendTransaction: (input: RecordSendTransactionInput) => void;
  recordSendTransactionAsync: (
    input: RecordSendTransactionInput
  ) => Promise<Transaction>;
  data: Transaction | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  isSuccess: boolean;
  reset: () => void;
} {
  const { chipiSDK } = useChipiContext();

  const mutation: UseMutationResult<
    Transaction,
    Error,
    RecordSendTransactionInput
  > = useMutation({
    mutationFn: (input: RecordSendTransactionInput) =>
      chipiSDK.recordSendTransaction({
        params: input.params,
        bearerToken: input.bearerToken,
      }),
  });

  return {
    recordSendTransaction: mutation.mutate,
    recordSendTransactionAsync: mutation.mutateAsync,
    data: mutation.data,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    isSuccess: mutation.isSuccess,
    reset: mutation.reset,
  };
}
